module.exports = __webpack_public_path__ + "static/media/letter-dark.8462fb4b.png";